var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipseClaro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-1",
    cx: 5,
    cy: 5,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#ellipse-1"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0,
    stroke: "#fff",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 4,
    mask: "url(#mask-2)",
    xlinkHref: "#ellipse-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipseClaro);
export default __webpack_public_path__ + "static/media/eclipse_claro.60609a63f1827c6279140e08b89591a5.svg";
export { ForwardRef as ReactComponent };